export default __webpack_public_path__ + "static/automotive-workflow-solutions-a85857978e9f58143836c56141daaa5f.png";